<template>
  <div>
    <b-form
      @submit="onSubmit"
      class="container"
      v-if="company && lookups"
    >
      <SubHeader title="Campaigns" />
      <b-row class="my-1">
        <b-col md="3">

        </b-col>
        <b-col md="9">
          <multiselect
            v-model="company.companyCampaign"
            tag-placeholder="Add this as new tag"
            placeholder="Search or add a tag"
            label="campaignName"
            track-by="campaignId"
            :options="lookups.campaigns"
            :multiple="true"
            :hide-selected="true"
                       :disabled="onTheMarket"
          ></multiselect>
        </b-col>
      </b-row>
      <SubHeader title="Marketing Tags" />
      <b-row class="my-1">
        <b-col md="3">

        </b-col>
        <b-col md="9">
          <multiselect
            v-model="company.companyMarketingTag"
            tag-placeholder="Add this as new tag"
            placeholder="Search or add a tag"
            label="marketingTagName"
            track-by="marketingTagId"
            :options="lookups.marketingTags"
            :multiple="true"
            :hide-selected="true"
                       :disabled="onTheMarket"
          ></multiselect>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3"> </b-col>
        <b-col md="6">
          <b-button
            class="my-1 margin-right"
            variant="success"
            type="button"
            @click="save"
                    :disabled="onTheMarket"
            ><font-awesome-icon icon="save" />&nbsp;Save</b-button
          >
          <b-button
            class="my-1"
            variant="danger"
            type="button"
            @click="reset"
                    :disabled="onTheMarket"
            ><font-awesome-icon icon="times" />&nbsp;Cancel Changes</b-button
          >
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">
        </b-col>
        <b-col md="6">
          <Feedback ref="saveFeedback"/>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import Multiselect from "vue-multiselect";
import CompanyService from "@/services/Company.service";
import Feedback from "@/components/shared/Feedback.vue";

export default {
  components: { SubHeader, Multiselect, Feedback },
  props: {
    initialCompany: Object,
    lookups: Object
  },
  mounted() {
    if (this.company && this.localCompany == null) {
      this.localCompany = { ...this.company };
    }
  },
  data() {
    return {
      company: null,
      onTheMarket:  false,
    };
  },
  watch: {
    initialCompany: function() {
      this.company = { ...this.initialCompany };
      this.onTheMarket = this.initialCompany.companyLocked;
    }
  },
  methods: {
    onSubmit() {

    },
    reset() {
      this.company = {...this.initialCompany}
    },
    save() {

      var form = {
        companyId: this.company.id,
        campaignIds: this.company.companyCampaign.map(x => x.campaignId),
        marketingTags: this.company.companyMarketingTag.map(x => x.marketingTagId),
      }

      CompanyService.saveCompanyTags(form).then(() => {
        this.$refs.saveFeedback.showSuccess("Save Successful");
      });
    },



  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
